import { isAfter } from 'date-fns';
import checkTaskPattern from 'helpers/validators/checkTaskPattern';
import { z } from 'zod';

const schema = z
  .object({
    project: z.string().min(1, { message: 'errors.field_required' }),
    description: z.string().refine((value) => checkTaskPattern(value)),
    endDate: z.date(),
    startDate: z.date(),
  })
  .refine((data) => isAfter(data.endDate, data.startDate), {
    message: 'error.date',
    path: ['endDate'],
  });

export default schema;
